import React, { useEffect } from 'react';

interface IRedirectProps {
    userToken: string;
    domainType: string;
    endpoint: string;
}

export const FormRedirect = (props: IRedirectProps): JSX.Element => {
    useEffect(() => {
        const formExists = document.getElementById('formToRedirect');
        const elementTokenExists = document.getElementById('formUserToken');
        const elementTypeExists = document.getElementById('formDomainType');
        if (formExists && elementTokenExists && elementTypeExists) {
            const formElement = document.getElementById('formToRedirect') as HTMLFormElement;
            formElement.submit();
        }
    });

    return (
        <form id="formToRedirect" action={props.endpoint} method="post">
            <input id="formUserToken" type="hidden" name="userToken" value={props.userToken} />
            <input id="formDomainType" type="hidden" name="domainType" value={props.domainType} />
        </form>
    );
};
